import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box, Text, useMedia } from '../../../Boneyard';
import { withTheme } from 'styled-components';
import { getPrice } from '@g4/next-furniture/Price/Price';

import { useTranslations } from '../../../../graphql/components/TranslationsProvider';

const propTypes = {
  promos: PropTypes.array.isRequired,
  isTripSummary: PropTypes.bool,
  theme: PropTypes.shape({
    colors: PropTypes.shape({
      cart: PropTypes.shape({
        promo: PropTypes.string.isRequired,
      }),
    }),
  }),
};

const FadeText = styled(Text)`
  color: #263238;
`;

const Promos = ({ theme, promos, isTripSummary }) => {
  const mq = useMedia();
  const translations = useTranslations();
  const { promosCartSectionHeading, promoAppliedLabel } = isTripSummary
    ? translations.paymentPage
    : translations.cart;

  return (
    <Box
      backgroundColor={theme.colors.cart.promo}
      pl={isTripSummary ? (mq.lte('md') ? 3 : 6) : 6}
      pt={2}
      pb={2}
      pr={isTripSummary ? (mq.lte('md') ? 3 : 6) : 6}
    >
      <Text weight={600} size={mq.lte('md') ? 14 : 16}>
        {promosCartSectionHeading}
      </Text>
      {promos.map((promo, index) => (
        <Box key={index} d="flex" justifyContent="space-between" pt={1}>
          <Text size={mq.lte('md') ? 12 : 15} weight={500}>
            {'total' in promo ? promo.description : promo.headlineDescription}
          </Text>

          <FadeText uppercase size={mq.lte('md') ? 12 : 14}>
            {'total' in promo
              ? getPrice(promo.total.amount, '$').price
              : promoAppliedLabel}
          </FadeText>
        </Box>
      ))}
    </Box>
  );
};

Promos.propTypes = propTypes;

export default withTheme(Promos);
